export default "/images/quote.png?4b9ff2066f61af660053a2535dc68fe3";